import International from 'components/account/International';
import SameCurrency from 'components/account/SameCurrency';
import React from 'react';
import { Tab, Tabs } from 'react-bootstrap';

function AccountPage() {
  return (
    <>
      <Tabs fill defaultActiveKey="International" id="uncontrolled-tab-example">
        <Tab eventKey="International" title="International" className="mt-4">
          <div className="leftContent">
            <International />
          </div>
        </Tab>
        <Tab eventKey="Same_currency" title="Same currency" className="mt-4">
          <div className="rightContent">
            <SameCurrency />
          </div>
        </Tab>
      </Tabs>
    </>
  );
}

export default AccountPage;
